import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const UploadBtn = () => {
  const navigate = useNavigate();
  const booking = useAppSelector((state) => state.booking);
  const { t } = useTranslation();

  const goToUploadDoc = () => {
    navigate("/uploadfile");
  };

  return (
    <button className="btnRounded w-100" onClick={goToUploadDoc}>
      {t("buttons.uploadPayment")}
    </button>
  );
};

export default UploadBtn;
